// src/components/CoverPage/CoverImage/index.jsx
import React, { useState, useRef, useEffect } from 'react'
import { withStyles, Typography, TextField, Tooltip } from '@material-ui/core'
import { Icon } from '@iconify/react'
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate'
import { CoreIconButton } from 'src/components/core'
import { AssignmentFieldNames } from 'src/model/assignment'
import styles from './styles'
import { useSelector, useDispatch } from 'react-redux'
import { PatchContent, PatchData } from 'src/model/patch'
import { coursePatchAction } from 'src/reducers/course/action'
import URL from 'src/api/url'
import ContainerMediaGalery from 'src/container/image-gallery'

import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'

const CoverImage = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const course = useSelector(state => state.course.course)
  const [coverImageUrl, setCoverImageUrl] = useState(null)
  const [title, setTitle] = useState(course?.name)

  useEffect(() => {
    if (course) {
      const newCoverUrl =
        course[AssignmentFieldNames.COVERIMAGEURL] != null &&
        course[AssignmentFieldNames.COVERIMAGEURL] !== ''
          ? course[AssignmentFieldNames.COVERIMAGEURL].includes('https')
            ? course[AssignmentFieldNames.COVERIMAGEURL]
            : `${URL.CDN}${course[AssignmentFieldNames.COVERIMAGEURL]}`
          : 'https://cdn.minicoursegenerator.com/assets/gateway/course-cover.png'

      setCoverImageUrl(
        newCoverUrl != null
          ? newCoverUrl.includes('https')
            ? newCoverUrl
            : URL.CDN + newCoverUrl
          : null,
      )
      setTitle(course.name)
    }
  }, [course])

  const handleTitleChange = event => {
    setTitle(event.target.value)
  }

  const onBlurTitle = value => {
    if (course?.name !== value) {
      const patchSource = new PatchData(null, course[AssignmentFieldNames.ID])
      patchSource.addContent(
        new PatchContent(
          value,
          AssignmentFieldNames.NAME,
          PatchData.OPERATION_REPLACE,
        ),
      )
      dispatch(coursePatchAction(patchSource, () => {}))
    }
  }

  const handleAddImage = () => {
    /**
     *
     * @param {} items
     */
    const onOk = items => {
      const item = items[0]

      const patchSource = new PatchData(null, course[AssignmentFieldNames.ID])
      patchSource.addContent(
        new PatchContent(
          `${item.url}`,
          AssignmentFieldNames.COVERIMAGEURL,
          PatchData.OPERATION_REPLACE,
        ),
      )
      dispatch(coursePatchAction(patchSource, () => {}))
      setCoverImageUrl(`${item.url}`)
      dispatch(messageBoxHideAction())
    }
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              "
            >
           
            <Icon
              icon="ic:round-add-a-photo"
              color="#00AB55"
              width="24"
              height="24"
            />
            <Typography
              style="
                margin-left: 8;
                color: #002E47;
                fontWeight: 600;
                fontSize: 16;
              "
            >
              Media Gallery
            </Typography>
          </div>`,
          variant: MessageBoxVariant.DRAGGABLE,
          component: (
            <ContainerMediaGalery onOk={onOk} popupType={'collection-edit'} />
          ),
          maxHeight: '640px',
        }),
      ),
    )
  }
  const themeSettingsStringified = course?.settingDtos?.find(
    setting => setting.key === 'theme',
  )
  const themeSettings = themeSettingsStringified
    ? JSON.parse(themeSettingsStringified?.value)
    : null

  const fontSize = themeSettings?.fontSize
  const font = themeSettings?.font

  return (
    <div className={classes.root__bg}>
      <div className={classes.root__section}>
        <div className={classes.image__bg}>
          {!coverImageUrl && (
            <div className={classes.image__icon} onClick={handleAddImage}>
              <AddPhotoAlternateIcon
                fontSize="inherit"
                style={{ fontSize: '2rem' }}
              />
              <span className={classes.image__span}>Change Cover Image</span>
            </div>
          )}
          <div
            style={{
              backgroundImage: coverImageUrl ? `url(${coverImageUrl})` : 'none',
            }}
            className={classes.image__content}
          >
            <TextField
              className={classes.textfield}
              InputProps={{
                className: classes.textfieldInput,
              }}
              multiline
              inputProps={{
                style: {
                  textAlign: 'center',
                  padding: 0,
                  fontFamily: font || 'Inter',
                },
              }}
              onBlur={e => onBlurTitle(e.target.value)}
              onChange={e => handleTitleChange(e)}
              value={title}
            ></TextField>
          </div>
          {coverImageUrl && (
            <Tooltip title="Change photo">
              <CoreIconButton
                variant="contained"
                color="white"
                size="small"
                className={classes.image__remove}
                onClick={handleAddImage}
              >
                <Icon icon="hugeicons:exchange-01" />
              </CoreIconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(CoverImage)
